module.exports = __webpack_public_path__ + "static/media/icon-arrow-up-gray.f06b3c64.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-arrow-up-gray.svg
// module id = 1882
// module chunks = 0